import type { AskUIMessage } from './askUiMessage';
import type { ChatFailure } from './chatFailure';
import { userMessageText } from './projectTurn';

interface RetryState {
  messages: ReadonlyArray<AskUIMessage>;
  failure: ChatFailure | null;
  working: boolean;
  readOnly: boolean;
  expired: boolean;
  historyPending: boolean;
  confirmingHistory: boolean;
  contextPending: boolean;
}

/** A restored error has no live SDK error, but can regenerate its original user message. */
export function canRetryLatestTurn(state: RetryState): boolean {
  if (
    state.working ||
    state.readOnly ||
    state.expired ||
    state.historyPending ||
    state.confirmingHistory ||
    state.contextPending ||
    state.failure?.kind === 'auth'
  ) {
    return false;
  }
  const latest = state.messages[state.messages.length - 1];
  const failed = Boolean(state.failure) || (latest?.role === 'assistant' && Boolean(latest.metadata?.errorText));
  if (!failed || (latest?.role !== 'assistant' && latest?.role !== 'user')) {
    return false;
  }
  const user = [...state.messages].reverse().find((message) => message.role === 'user');
  return Boolean(user && userMessageText(user).trim());
}
